import { configureStore } from "@reduxjs/toolkit";
import LoginReducer from "./slice/login-slice";
import DashboardReducer from "./slice/dashboard-slice";
import ConnectionReducer from "./slice/connection-slice";
import ConsentManagementReducer from "./slice/consent-management-slice";
import AudienceManagementReducer from "./slice/audience-management-slice";
import CommonReducer from "./slice/common-slice";
import CompanyReducer from "./slice/company-slice";
import AccountReducer from "./slice/account-slice";

import UserReducer from "./slice/user-slice";
import PublisherReducer from "./slice/publisher-slice";
import RoleReducer from "./slice/role-slice";
import AdvertiserReducer from "./slice/advertiser-slice";
import CampaignReducer from "./slice/campaign-slice";
import ThemeReducer from "./slice/theme-slice";
import SupplyReducer from "./slice/supply-slice";
import SupplyDealReducer from "./slice/supply-deal-slice";
import ReportReducer from "./slice/report-slice";
import TargetingGroupReducer from "./slice/targeting-groups-slice";
import PaymentReducer from "./slice/payment-slice";
import DemandPartnerReducer from "./slice/demand-partner-slice";
import PrivateMarketPlaceReducer from "./slice/private-market-place-slice";
import AnalyticsDashboardReducer from "./slice/analytics-dashboard-slice";
import SupplyDashboardReducer from "./slice/supply-dashboard-slice";
import AudiencePixelsReducer from "./slice/audience-pixels-slice";
import DashboardUserRolesReducer from "./slice/dashboard-user-role-slice";
import CampaignAllReportReducer from "./slice/campaign-all-report-slice";
import AudiencePixelAllReportReducer from "./slice/audience-pixel-report-slice";
import CampaignAttributionReportReducer from "./slice/campaign-attribution-report-slice";

const store = configureStore({
  reducer: {
    LoginReducer: LoginReducer,
    DashboardReducer: DashboardReducer,
    ReportReducer: ReportReducer,
    ConnectionReducer: ConnectionReducer,
    ConsentManagementReducer: ConsentManagementReducer,
    AudienceManagementReducer: AudienceManagementReducer,
    CommonReducer: CommonReducer,
    CompanyReducer: CompanyReducer,
    AccountReducer: AccountReducer,
    CampaignReducer: CampaignReducer,
    UserReducer: UserReducer,
    PublisherReducer: PublisherReducer,
    SupplyReducer: SupplyReducer,
    RoleReducer: RoleReducer,
    AdvertiserReducer: AdvertiserReducer,
    ThemeReducer: ThemeReducer,
    SupplyDealReducer: SupplyDealReducer,
    TargetingGroupReducer: TargetingGroupReducer,
    PaymentReducer: PaymentReducer,
    DemandPartnerReducer: DemandPartnerReducer,
    PrivateMarketPlaceReducer: PrivateMarketPlaceReducer,
    AnalyticsDashboardReducer: AnalyticsDashboardReducer,
    SupplyDashboardReducer: SupplyDashboardReducer,
    AudiencePixelsReducer: AudiencePixelsReducer,
    DashboardUserRolesReducer: DashboardUserRolesReducer,
    CampaignAllReportReducer: CampaignAllReportReducer,
    AudiencePixelAllReportReducer: AudiencePixelAllReportReducer,
    CampaignAttributionReportReducer: CampaignAttributionReportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export default store;
export const { dispatch } = store;
